"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _NotificationMiddleware = _interopRequireDefault(require("ReduxMessenger/middleware/NotificationMiddleware"));

var _reducers = _interopRequireDefault(require("../reducers"));

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default, _NotificationMiddleware.default))(_redux.createStore);

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createStoreWithMiddleware(_reducers.default, initialState);
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/configureStore.js
// module id = 630
// module chunks = 209 210 211 212